/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

export const isIpadOS = (userAgent?: string) => {
  if (!userAgent) {
    return false
  }
  const ua = userAgent.toLowerCase()
  return (
    ua.match(/(ipad)/) || (/macintosh|mac os x/i.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2)
  )
}

export const isAndroidPhone = (userAgent?: string) => {
  if (!userAgent) return false
  const ua = userAgent.toLowerCase()
  return !!ua.match(/android/) && !!ua.match(/mobile/)
}

export const isPhone = (userAgent?: string) => {
  if (!userAgent) return false
  const ua = userAgent.toLowerCase()
  return (
    !!ua.match(/(micromessenger|webbrowser|windows whone|blackberry|ipod|iphone|webos)/) || isAndroidPhone(userAgent)
  )
}

export const isIOS = () => {
  return !!navigator.userAgent.toLowerCase().match(/(ipod|iphone)/)
}

export const isMobile = () => {
  return isPhone(navigator.userAgent) || isIpadOS(navigator.userAgent) || isAndroidPhone(navigator.userAgent)
}
